const config = {
    baseUrl : process.env.VUE_APP_BASE_URL,
    apiKey : process.env.VUE_APP_API_KEY
}

export default config;